import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { currentTime, getCurrentTime, today } from "../../Js/Date";
import { update_login_response } from "../../Redux/Login/loginResponseSlice";
import { update_search_user_response } from "../../Redux/Login/searchUserSlice";
import { update_userRole } from "../../Redux/Login/userRoleSlice";
import store from "../../Redux/store";
import Store from "../../Redux/store";
import { getShiftStatusAPICAll } from "../Settings/Shift/viewShiftAPI";
import { HEADERS } from "../UrlAndPaths";
import { errorSnackMsg } from "../../component/Custom Hooks/SnackkBarUtilities";
import { setSubmitLoading } from "../../Redux/Dashboard/mainDashBoardSlice";
import { get_branch_configuration_list } from "../../component/Modules/Sales/Billing/newBillingSlice";
import { get_branch_settings_row_data_list } from "../../component/Modules/PointOfSale/Configuration/BranchSettings/BranchSettingsSlice";
import { setPosDevice } from "../../component/Modules/Sales/Billing/Slice/posDeviceSlice";
import { storeUserPermissions, calculateEffectivePermissions } from "../../utils/permissions";

//Search User by userName
export const searchUserByUSerNameAPICall = async (body,userRoleClearFn) => {
  store.dispatch(setSubmitLoading(true))
  await axios
  .post("admin/searchuser", body, HEADERS)
  .then((res) => {
    if (res.status === 200) {
        store.dispatch(setSubmitLoading(false))
        Store.dispatch(
          update_search_user_response({ searchUserData: res.data })
        );
        localStorage.setItem("userRole", res.data?.role);
        store.dispatch(update_userRole({ userRole: res.data?.role }));
      }
    })
    .catch((err) => {
      store.dispatch(setSubmitLoading(false))
      userRoleClearFn?.()
      errorSnackMsg("User not found !!")
    });
};

//Final Login
export const finalLoginAPICall = async (
  body
) => {
  store.dispatch(setSubmitLoading(true))

  try {
    const res = await axios.post("admin/login", body, HEADERS)
    if (res.status === 200) {
      localStorage.setItem("userToken", res.data.token);
      localStorage.setItem("isAuth", true);
      localStorage.setItem("branchId", jwtDecode(res?.data?.token)?.branchId);
      localStorage.setItem("login_meta", JSON.stringify(res.data));
      localStorage.setItem("userInfo", JSON.stringify({ userName: res?.data?.userName, imageUrl: res?.data?.imageUrl, }));

      store.dispatch(update_login_response({ loginResponse: res.data }));

      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${res.data.token}`;

      // RBAC: Store user permissions from JWT token - Phase 6 Part 2
      const decodedToken = jwtDecode(res?.data?.token) || {};
      const roles = decodedToken?.roles || ['EMPLOYEE'];
      const permissionOverrides = decodedToken?.permissionOverrides || {};
      
      const userData = {
        ...res.data,
        roles,
        permissionOverrides,
        permissions: calculateEffectivePermissions(roles, permissionOverrides),
      };
      
      storeUserPermissions(userData);

      let userRole = decodedToken?.role
      if (userRole === 'user') {
        getShiftStatusAPICAll({ branchId: decodedToken?.branchId, curTime: `${today} ${getCurrentTime()}` })
      }

      // Auto-load POS configuration and assign device
      const branchId = decodedToken?.branchId;
      const employeeId = decodedToken?._id || decodedToken?.id;

      if (branchId) {
        try {
          // 1. Basic POS branch configuration (for backwards compatibility)
          const basicConfigRes = await axios.post(
            "settings/posBranchWiseConfig",
            { branchId },
            HEADERS
          );
          if (basicConfigRes.status === 200) {
            store.dispatch(get_branch_configuration_list(basicConfigRes.data));
          }
        } catch (err) {
          console.warn("Failed to load POS branch config", err?.response || err);
        }

        try {
          // 2. Full branch settings with device data
          const fullConfigRes = await axios.post(
            "settings/viewUserbranchSettings",
            { _id: branchId },
            HEADERS
          );

          if (fullConfigRes.status === 200) {
            const settingsData = fullConfigRes.data;
            store.dispatch(
              get_branch_settings_row_data_list({ branchSettingsSingleData: settingsData })
            );

            // Resolve device assigned to logged-in employee
            const devices = Array.isArray(settingsData?.posDevices)
              ? settingsData.posDevices
              : [];

            const matchedDevice = devices.find((device) => {
              if (!Array.isArray(device?.employees)) return false;
              return device.employees.some((emp) => {
                const empId = emp?.empId || emp?._id;
                return empId && empId.toString() === employeeId?.toString();
              });
            });

            if (matchedDevice) {
              const normalizedEmployees = Array.isArray(matchedDevice?.employees)
                ? matchedDevice.employees
                    .map((emp) => {
                      const empId = emp?.employeeId || emp?.empId || emp?._id;
                      if (!empId) return null;
                      return {
                        employeeId: empId.toString(),
                        employeeName:
                          emp?.name || emp?.staff_name || emp?.employeeName || "",
                      };
                    })
                    .filter(Boolean)
                : [];

              const normalizedCategories = Array.isArray(
                matchedDevice?.categories
              )
                ? matchedDevice.categories
                    .map((cat) => {
                      const catId = cat?.categoryId || cat?._id;
                      if (!catId) return null;
                      return {
                        categoryId: catId.toString(),
                        categoryName:
                          cat?.categoryName || cat?.name || cat?.category || "",
                      };
                    })
                    .filter(Boolean)
                : [];

              store.dispatch(
                setPosDevice({
                  deviceId: matchedDevice?._id?.toString() || matchedDevice?.deviceId,
                  deviceName: matchedDevice?.deviceName || matchedDevice?.name || null,
                  assignedEmployeeId: employeeId?.toString() || null,
                  assignedEmployees: normalizedEmployees,
                  assignedCategories: normalizedCategories,
                  assignedAt: new Date().toISOString(),
                  branchId: branchId?.toString() || null,
                  allowSpecialItems: Boolean(
                    matchedDevice?.allowSpecialItems ?? matchedDevice?.specialPosCategory
                  ),
                })
              );
            } else {
              store.dispatch(setPosDevice(null));
            }
          }
        } catch (err) {
          console.warn("Failed to load full branch settings", err?.response || err);
          store.dispatch(setPosDevice(null));
        }
      } else {
        store.dispatch(setPosDevice(null));
      }
    }
  } catch (err) {
    let message = null
    let showForgotPassword = false

    if (err === undefined) {
      message = "Network Error!!"
    }
    if (err.response?.status === 500) {
      message = "Server error !!"
    }
    if (err.response?.status === 401) {
      message = err.response?.data?.data?.msg || "Invalid password!!"
      showForgotPassword = err.response?.data?.data?.showForgotPassword || false
    }
    if (err.response?.status === 403) {
      message = err.response?.data?.data?.msg || err.response?.data?.msg || "You are not authorized to login from this device. Please contact admin."
      showForgotPassword = err.response?.data?.data?.showForgotPassword || false
    }
    
    store.dispatch(update_login_response({ loginResponse: undefined }));
    errorSnackMsg(message)
    
    // Return error info including showForgotPassword flag
    return { error: true, message, showForgotPassword }
  } finally {
    store.dispatch(setSubmitLoading(false))
  }
};
// export const finalLoginAPICall = async (
//   body,
//   setIsSuccess,
//   setError,
//   setErrorMsg
// ) => {
//   await axios
//     .post("admin/login", body, HEADERS)
//     .then((res) => {
//       if (res.status === 200) {
//         let userRole=null
//         localStorage.setItem("userToken", res.data.token);
//         localStorage.setItem("isAuth", true);
//         localStorage.setItem("branchId", jwtDecode(res?.data?.token)?.branchId);
//         localStorage.setItem(
//           "userInfo",
//           JSON.stringify({
//             userName: res?.data?.userName,
//             imageUrl: res?.data?.imageUrl,
//           })
//         );
//         axios.defaults.headers.common[
//           "Authorization"
//         ] = `Bearer ${res.data.token}`;
//         setIsSuccess(true);
//         localStorage.setItem("login_meta", JSON.stringify(res.data));
//         store.dispatch(update_login_response({ loginResponse: res.data }));
//         userRole=jwtDecode(res?.data?.token)?.role
//         if(userRole!==null)
//         {
//           if(userRole==='user')
//           {
//             getShiftStatusAPICAll({branchId:jwtDecode(res?.data?.token)?.branchId,curTime:`${today} ${getCurrentTime()}`})
//           }
//         }

//       }
//     })
//     .catch((err) => {
//       if (err === undefined) {
//         setErrorMsg("Network Error!");
//       }
//       if (err.response.status === 500) {
//         setErrorMsg("Server error!");
//       }
//       if (err.response.status === 401) {
//         setErrorMsg("Invalid Password!!");
//       }
//       store.dispatch(update_login_response({ loginResponse: undefined }));
//       setError(true);
//       console.error(err.response);
//     });
// };

//Update Employee UserName and Password
export const updateEmpUsernamePasswordAPICall = async (
  body,
  setSuccess,
  setError,
  setSnackMsg,
  updateListener,
  clearStates
) => {
  await axios
    .put("employee/updateemployeecredentials", body, HEADERS)
    .then((res) => {
      if (res.status == 200) {
        console.log("Password changed successfully");
        setSnackMsg("Password changed 👍");
        setSuccess(true);
        updateListener();
        clearStates();
      }
    })
    .catch((err) => {
      switch (err.response.status) {
        case undefined:
          setSnackMsg("Network error!!");
          break;
        case 401:
          setSnackMsg("Unauthorized!!");
          break;
        case 403:
          setSnackMsg("Forbidden!!");
          break;
        case 409:
          setSnackMsg("Same password!!");
          break;
        case 500:
          setSnackMsg("Server error!!");
          break;

        default:
          break;
      }
      setError(true);
    });
};
